module.exports = __webpack_public_path__ + "static/img/en-about-banner.91f2c86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/en-about-banner.jpg
// module id = Hp0q
// module chunks = 2